<div class="fr-icon">
  @if (franchiseRoute().includes('ca')) {
    <img [src]="FRANCHISE_FLAGS.ca" alt="Canada">
  } @else if (franchiseRoute().includes('de')) {
    <img [src]="FRANCHISE_FLAGS.de" alt="Deutsch">
  } @else if (franchiseRoute().includes('gb')) {
    <img [src]="FRANCHISE_FLAGS.gb" alt="Great Britain">
  } @else {
    <i class="icon-GlobeSimple"></i>
  }
</div>
